export default "__VITE_ASSET__BIPOEN3A__"